import { CalendarIcon } from "../ui/icons";

// Web port of EventThumbnailView
// (EventsFeature/View/Component/EventThumbnailView.swift).
//
// Always draws something: events without artwork would otherwise sit visibly
// out of line with the rest of a list.

export default function EventThumbnail(props: { url: string | null, alt?: string }) {
  if (props.url) {
    return <img
      src={props.url}
      alt={props.alt ?? ""}
      className="size-full object-cover"
    />
  }

  return <div className="flex size-full items-center justify-center bg-linear-to-br from-gray-500/25 to-gray-500/10">
    <CalendarIcon className="size-6 shrink-0 text-gray-500" />
  </div>
}
